(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("i18n/fy", [], factory);
	else if(typeof exports === 'object')
		exports["i18n/fy"] = factory();
	else
		root["i18n/fy"] = factory();
})(window, function() {
return 